import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesASAP from "./stylesASAP";
import stylesMed from "../MedRep/stylesMed";
import Loading from "../Loading";

export default class Catalogs extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      checked: [],
      catalogs: [],
      catalogsCopy: [],
      allCatalogs: [],
      clients: [],
      clientsCopy: [],
      clientIndex: -1,
      showClients: false,
      disableClient: false,
      selectedClient: 0,
      token: "",
      authenticate: false,
      alertUndefined: false,
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    const token = localStorage.getItem("Token");
    await this.setState({ token: JSON.parse(token) });
    const catalogs = JSON.parse(localStorage.getItem("Catalogs"));
    const catalogType = JSON.parse(localStorage.getItem("CatalogType"));
    this.setState({
      catalogs: catalogs,
      catalogsCopy: catalogs,
      loading: false,
      catalogType: catalogType,
    });
  }

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.clients,
      this.state.clientsCopy,
      this.state.noData
    );
    this.setState({ clients: values.items, noData: values.noData });
  };

  onItemClick = (item) => {
    if (this.state.catalogType === 2) {
      this.props.history.push("./Items");
    } else {
      this.props.history.push("/ProductsASAP");
    }

    localStorage.setItem("CatalogId", JSON.stringify(item));
  };

  render() {
    if (!this.state.loading) {
      return (
        <div
          className="container-fluid vh-100 "
          style={stylesASAP.mainContainer}
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.goBack()}
              color={"#65a0ff"}
              height="50px"
              width="50px"
            />
          </div>
          <p className="pt-3 text-center h3" style={stylesASAP.itemName}>Catalog List</p>
          <div className="pt-2">
    <div className="row mt-5">
        {this.state.catalogs.map((item, index) => (
            <div className="col-md-6 pt-3" key={index}>
                <div className="card text-center">
                    <div className="card-body btn catalog rounded-3 shadow" style={stylesASAP.fullwidth}  onClick={() => this.onItemClick(item.id)}>
                        <h5 className="card-title mb-3" style={stylesASAP.itemName2}>{item.name}</h5>
                       
                    </div>
                </div>
            </div>
        ))}
    </div>
</div>

        </div>
      );
    } else {
      return (
        <Loading
          history={this.props.history}
          page={"./Order"}
          name={"Catalog"}
          search={false}
        ></Loading>
      );
    }
  }
}
